document.addEventListener('DOMContentLoaded', function() {
  // Save the skio-plan-picker fieldset element
  const skioPlanPicker = document.querySelector('.skio-plan-picker');
  
  // Save all skio-group-container elements
  const skioGroupContainers = document.querySelectorAll('.skio-group-container');
  
  let activeSkioGroupContent = null;  // Track the currently active skioGroupContent
  
  skioGroupContainers.forEach(container => {
    // Check if the container has an input with the 'data-skio-selling-plan-group' attribute
    const input = container.querySelector('input[skio-selling-plan-group]');
    
    if (input) {
      container.addEventListener('click', function() {
        // Save the skio-group-content div inside the clicked container
        const skioGroupContent = container.querySelector('.skio-group-content');
        console.log("xxx", skioGroupContent)
        
        if (skioGroupContent) {
          // Remove the previously active skioGroupContent, if it exists
          if (activeSkioGroupContent && activeSkioGroupContent !== skioGroupContent) {
            activeSkioGroupContent.remove();
          }
          
          // Append the skioGroupContent as the last child of the skio-plan-picker
          skioPlanPicker.appendChild(skioGroupContent);
          
          // Update the active skioGroupContent
          activeSkioGroupContent = skioGroupContent;
        }
      });
    }
  });
});
